export default function visualReport() {
  const init = import(/* webpackChunkName: "visualReport" */ "./init")
  const vue = import(/* webpackChunkName: "vue" */ "vue/dist/vue.runtime.esm")

  const {
    location_name: locationName,
    location_filename: locationFilename,
    running_inside_app: runningInsideApp,
  } = window.FCGON

  return Promise.all([vue, init]).then(([{ default: Vue }, { default: VisualReport }]) =>
    VisualReport(Vue, { locationName, locationFilename, runningInsideApp }),
  )
}
